import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import CreateIcon from "@mui/icons-material/Create";
import { IconButton, TableCell, TableRow } from "@mui/material";

import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import { getTranslateByKey } from "@/main/services/utils";
import { formatCurrency } from "@/main/services/utilsNumber";

import { IDataPriceList } from "../sectionPriceList";
import * as S from "./styles";

interface IGridPriceListProps {
	dataPriceList: IDataPriceList[];
	setDataPriceList: React.Dispatch<React.SetStateAction<IDataPriceList[]>>;
	setIdClientEdit: React.Dispatch<React.SetStateAction<string>>;
}

function GridPriceList({ dataPriceList, setDataPriceList, setIdClientEdit }: IGridPriceListProps) {
	const rowHeaders = [
		getTranslateByKey("information.companyTypeName"),
		getTranslateByKey("information.company"),
		getTranslateByKey("information.shippingPrice"),
		getTranslateByKey("information.autoDeliveryWithCost"),
		getTranslateByKey("information.autoDeliverywithoutPrice"),
		"", // Actions
	];

	const sizeCollumns = [
		"20%", // Company Type,
		"responsive", // Company,
		"15%", // Logistic Company,
		"15%", // Auto Delivery With Cost,
		"15%", // Auto Delivery Without Cost,
		"80px", // Actions
	];

	function editPrice(priceList: IDataPriceList) {
		setIdClientEdit(priceList.idClient);
	}
	function deletePrice(priceList: IDataPriceList) {
		setIdClientEdit("");
		setDataPriceList(dataPriceList.filter((price) => price.idClient !== priceList.idClient));
	}
	const ACTIONS_BUTTONS = [
		{
			id: "id-register-inventory-price-list-edit",
			onClick: editPrice,
			icon: <CreateIcon />,
		},
		{
			id: "id-register-inventory-price-list-delete",
			onClick: deletePrice,
			icon: <CloseIcon />,
		},
	];
	if (dataPriceList.length === 0) return <></>;

	return (
		<S.Container>
			<BoxGrid rowHeaders={rowHeaders} sizeColumns={sizeCollumns}>
				{dataPriceList.map((priceList, index) => (
					<TableRow id={`id-register-inventory-price-list-${index}`} key={priceList.idClient}>
						<TableCell>{priceList.companyType?.value}</TableCell>
						<TableCell title={priceList.isAllCompany ? getTranslateByKey("information.all") : priceList.company?.value}>
							<div
								style={{
									textOverflow: "ellipsis",
									overflow: "hidden",
									whiteSpace: "nowrap",
								}}
							>
								{priceList.isAllCompany ? getTranslateByKey("information.all") : priceList.company?.value}
							</div>
						</TableCell>
						<TableCell>
							{priceList.isNoPriceLogisticCompany
								? getTranslateByKey("importInventory.noPrice")
								: formatCurrency(Number(priceList.priceLogisticCompany))}
						</TableCell>
						<TableCell>
							{priceList.isNoPriceAutoDeliveryWithCost
								? getTranslateByKey("importInventory.noPrice")
								: formatCurrency(Number(priceList.priceAutoDeliveryWithCost))}
						</TableCell>
						<TableCell>
							{priceList.isNoPriceAutoDeliveryWithoutCost
								? getTranslateByKey("importInventory.noPrice")
								: formatCurrency(Number(priceList.priceAutoDeliveryWithoutCost))}
						</TableCell>
						<TableCell width="5%">
							<S.AreaActions>
								{ACTIONS_BUTTONS.map((action, actionIndex) => (
									<IconButton
										key={actionIndex}
										id={`${action.id}-${priceList.idClient}`}
										onClick={() => action.onClick(priceList)}
									>
										{action.icon}
									</IconButton>
								))}
							</S.AreaActions>
						</TableCell>
					</TableRow>
				))}
			</BoxGrid>
		</S.Container>
	);
}

export default GridPriceList;
